import { useQuery } from '@tanstack/react-query';
import { makeRemoteGetUserInfo } from 'main/factories/usecases/remote-get-user-info';

export const useHoneGetUserInfo = (userId: string, locationId: string | undefined, isOpen: boolean) => {
  const locationUser = makeRemoteGetUserInfo();
  return useQuery({
    enabled: !!locationId && !!userId && !!localStorage.getItem('hone:session'),
    queryKey: ['userInfo', locationId, userId, isOpen],
    queryFn: async () => {
      if (!userId) return undefined;
      return locationUser.get({ userId, locationId });
    },
  });
};
